// Loading screen and fly-in.
import * as THREE from 'three';
import { PI } from '../lib/math.js';
import { cam, controls } from '../core/scene.js';
import { V } from '../world/sagrada.js';
import { S, lookAt, startRide } from '../game/ride.js';
import { nameGroup } from '../game/intro.js';
import { state } from '../core/state.js';
import { go, introSub } from '../dom.js';

export let splashProgress, worldReady, flyCam;

export function buildSplash() {
  splashProgress = function splashProgress(p) {
    if (!splash) return;
    const bar = splash.querySelector('.bar');
    bar.classList.remove('busy');
    bar.firstElementChild.style.width = Math.round(p * 100) + '%';
  };
  worldReady = function worldReady() {
    splashProgress(1);
    if (!splash) {
      startRide();
      return;
    }
    // the welcome message and START replace the progress bar; the ride begins only when the visitor asks for it
    setTimeout(() => {
      splash.classList.add('ready');
      const btn = splash.querySelector('.start');
      btn.focus({ preventScroll: true });
      const go = () => {
        if (state.mode === 'flyin' || !splash.isConnected) return;
        removeEventListener('keydown', key);
        beginFlyIn();
      };
      const key = (e) => {
        if (e.code === 'Enter' || e.code === 'Space') {
          e.preventDefault();
          go();
        }
      };
      btn.addEventListener('click', go);
      addEventListener('keydown', key);
    }, 500);
  };
  flyCam = function flyCam(dt) {
    fly.t += dt;
    // hold over the plan while it dissolves, then descend with an ease-in-out; the path bows up so it doesn't skim roofs
    const u = Math.min(1, Math.max(0, (fly.t - 0.9) / 3.4)),
      e = u * u * u * (u * (u * 6 - 15) + 10);
    cam.position.lerpVectors(fly.p0, fly.p1, e);
    cam.position.y += Math.sin(e * PI) * 12;
    cam.quaternion.slerpQuaternions(fly.q0, fly.q1, Math.min(1, e * 1.15));
    cam.fov = fly.fov0 + (fly.fov1 - fly.fov0) * e;
    cam.updateProjectionMatrix();
    if (u >= 1) {
      startRide();
      lookAt.copy(fly.look1);
      cam.position.copy(fly.p1);
      fly = null;
    }
  };
  // ---------- loading screen → fly-in ----------
  // The splash (inked plan, drawn in index.html) covers the page while the city is built and the characters load.
  // Then the camera starts straight above the island at the plan's scale, the plan fades away over the real city,
  // and the camera swoops down behind the scooter, handing over to riding.
  const splash = document.getElementById('splash');
  splashProgress(0.4); // the city itself is built by the time this line runs
  let fly = null;
  function beginFlyIn() {
    if (!splash) {
      startRide();
      return;
    }
    state.mode = 'flyin';
    nameGroup.visible = false;
    controls.enabled = false;
    go.style.display = 'none';
    introSub.style.display = 'none';
    if (cam.aspect < 1) state.camDist = Math.min(state.camDist, 10);
    const s = window.PLAN_SCALE || (Math.min(innerWidth, innerHeight) * 0.9) / 150,
      fov0 = 40;
    const h = innerHeight / 2 / (s * Math.tan(THREE.MathUtils.degToRad(fov0 / 2)));
    state.camHead = S.th;
    const p1 = V(
        S.x - Math.sin(state.camHead) * state.camDist,
        S.y + state.camDist * 0.8 + 2,
        S.z - Math.cos(state.camHead) * state.camDist,
      ),
      look1 = V(S.x + Math.sin(S.th) * 3, S.y + 1.4, S.z + Math.cos(S.th) * 3);
    const q1 = new THREE.Quaternion().setFromRotationMatrix(
      new THREE.Matrix4().lookAt(p1, look1, V(0, 1, 0)),
    );
    fly = {
      t: 0,
      p0: V(0, h, 0),
      q0: new THREE.Quaternion().setFromEuler(new THREE.Euler(-PI / 2, 0, 0)),
      p1,
      q1,
      look1,
      fov0,
      fov1: cam.aspect < 1 ? 50 : 32,
    };
    flyCam(0);
    splash.classList.add('gone');
    setTimeout(() => splash.remove(), 1800);
  }
}
